// Up and down arrows drive the product gallery instead of scrolling the page.
//
// Pitch's slideshow already answers to left and right when it holds focus.
// This maps the vertical pair onto the same two methods, because the gallery
// is the tall thing on the page and up/down is what a hand reaches for while
// looking at it.
//
// Deliberately narrow, since taking the arrow keys away from scrolling is a
// real cost to anyone navigating by keyboard:
//
//   - product templates only, and only while a gallery is actually on screen;
//   - never while typing, or inside a dialog (the zoom view and the cart
//     drawer both run their own key handling);
//   - never alongside a modifier, so Cmd/Alt+Down still jump the document.
//
// When none of those hold, the event is left alone and the page scrolls as
// it always did.

const TYPING = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

/** @param {EventTarget | null} target */
function isTyping(target) {
  if (!(target instanceof HTMLElement)) return false;
  return TYPING.has(target.tagName) || target.isContentEditable;
}

/** @param {Element} el */
function isOnScreen(el) {
  const { top, bottom } = el.getBoundingClientRect();
  // Any overlap with the viewport counts: the gallery is tall enough that
  // requiring it to be fully visible would switch the behaviour off exactly
  // when someone is looking at the bottom of it.
  return bottom > 0 && top < window.innerHeight;
}

function handleKeydown(event) {
  if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') return;
  if (event.defaultPrevented) return;
  if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
  if (isTyping(event.target)) return;
  if (event.target instanceof Element && event.target.closest('dialog')) return;
  if (document.querySelector('dialog[open]')) return;

  const slideshow = document.querySelector('media-gallery slideshow-component');
  if (!slideshow || !isOnScreen(slideshow)) return;

  // The slideshow's own next/previous call preventDefault on what they are
  // handed, which is what stops the page scrolling underneath.
  if (event.key === 'ArrowDown') slideshow.next?.(event);
  else slideshow.previous?.(event);
}

// The template name lives on #MainContent, not on <body>. The script is
// deferred, so the element is parsed by the time this runs.
if (document.getElementById('MainContent')?.dataset.template?.startsWith('product')) {
  document.addEventListener('keydown', handleKeydown);
}
